import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { history } from "../../../shared/configure-store";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import Api from "../../../libraries/api";
import AuthHelper from "../../../libraries/auth-helper";

class Companies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showDialog: false,
            errors: {},
            orderBy: 'name',
            sortedBy: '',
            searchBy: '',
            rows: [],
            total: 0,
            perPage: 20,
            currentPage: 0,
            totalPages: 1,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Company';
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map(o => ({
                id: o.id,
                name: o.menu.name,
                isCreate: o.isCreate,
                isManage: o.isManage,
            }));



            // TODO: FIX PERMISSION TO COMPANY
            let all = roles.filter(item => item.name === 'Customer');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });



        }
        this.__fetchData(false);
    }

    __fetchData = (update) => {
        this.setState({ loading: true });
        const page = update ? 0 : this.state.currentPage;
        const params = {
            page: page,
            size: this.state.perPage,
            // 'search-by': this.state.searchBy,
            search: this.state.searchBy,
            sort: [{
                'column-name': this.state.orderBy,
                'is-ascending': this.state.sortedBy === 'asc',
            }]
        };

        Api.post('/company/find-all', params).then(resp => {
            const { data } = resp;
            this.setState({
                rows: data.content,
                total: data.totalElements,
                currentPage: data.number,
                totalPages: data.totalPages,
                perPage: data.size,
                loading: false
            });
        }).catch(err => {
            this.setState({ errors: err, loading: false });
        });
    };

    handleSearch = () => {
        this.__fetchData(false);
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;
        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }
        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    };

    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: row.name,
        });
    };

    handleClose = () => {
        this.setState({ showDialog: false });
    };

    handleDelete = () => {
        if (this.state.idDelete) {
            let params = {
                listId: [this.state.idDelete]
            };

            Api.delete('/company', params).then(resp => {
                this.setState({ showDialog: false });
                this.showMessage(true, 'Company berhasil dihapus');
                this.__fetchData(true);
            }).catch(err => {
                this.setState({ showDialog: false });
            });
        }
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleChangePage = (_, newPage) => {
        this.setState({ rows: [], currentPage: newPage, currentPageTable: newPage, loading: true }, () => this.__fetchData(false));
    };

    handleChangeRowsPerPage = (e) => {
        this.setState({ perPage: parseInt(e.target.value, 10), currentPage: 1, loading: true }, () => this.__fetchData(false));
    };

    handleGo = (link) => history.push(link);

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Data Company</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Data Company</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper pb-0">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Daftar Company</h2>
                            </div>
                            <div className="col-6 text-right">
                                {this.state.isManage &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.handleGo('/companies/add')}
                                    >
                                        <i className="fas fa-plus mr-2"></i>
                                        Buat Company
                                    </Button>
                                }
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search click" onClick={this.handleSearch}><i className="fas fa-search"> </i></IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('name')}>
                                            Nama Company
                                            {this.state.orderBy === 'name' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        {/* <TableCell className="clickable" onClick={() => this.handleSort('name_in_region')}>
                                            Nama Komunitas
                                            {this.state.orderBy === 'name_in_region' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell> */}
                                        <TableCell className="clickable" onClick={() => this.handleSort('email')}>
                                            Email
                                            {this.state.orderBy === 'email' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('phone')}>
                                            Telepon
                                            {this.state.orderBy === 'phone' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('address')}>
                                            Alamat
                                            {this.state.orderBy === 'address' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.length === 0 ? (
                                            <TableRow style={{ height: 33 * this.state.perPage }}>
                                                <TableCell colSpan={6} style={{ textAlign: "center" }}>Data Company kosong</TableCell>
                                            </TableRow>
                                        ) : (
                                            this.state.rows.map(row => (
                                                <TableRow key={row.id}>
                                                    <TableCell>{row.name}</TableCell>
                                                    {/* <TableCell>{row.name_in_region}</TableCell> */}
                                                    <TableCell>{row.email}</TableCell>
                                                    <TableCell>{row.phone}</TableCell>
                                                    <TableCell>{row.address}</TableCell>
                                                    <TableCell className='action-menu'>
                                                        <button className="btn-icon">
                                                            <i className="fas fa-ellipsis-v"> </i>
                                                        </button>
                                                        <div className='action-wrap'>
                                                            <Link to={`/companies/edit/${row.id}`} className="btn-icon mb-2">
                                                                <i className="fas fa-pencil-alt"> </i> Ubah
                                                            </Link>
                                                            {/* {this.state.isManage &&
                                                                <button className="btn-icon" onClick={() => this.handleOpen(row)}>
                                                                    <i className="fas fa-trash-alt"> </i> Hapus
                                                                </button>
                                                            } */}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPage}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>
                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">KONFIRMASI {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>Apakah anda yakin akan menghapus?</p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleClose}>Batal</button>
                        <button className="btn btn-blue" onClick={this.handleDelete}>Hapus</button>
                    </DialogActions>
                </Dialog>
                <ToastContainer />
            </div>
        );
    }
}

export default Companies;